export class TemplateNumericalInspection {
    id = 0;
    description = '';
    minValue = null;
    maxValue = null;
    unit = '';
}
